// extracted by mini-css-extract-plugin
export default {"breadCrumbItem":"style_breadCrumbItem__XTm8Z","currentItem":"style_currentItem__Fck+W"};